// extracted by mini-css-extract-plugin
export default {"footerButtonContainer":"SharedWith__footerButtonContainer___qUuxP"};